import { render, staticRenderFns } from "./index-online-learning.vue?vue&type=template&id=67d6def2"
import script from "./index-online-learning.vue?vue&type=script&lang=js"
export * from "./index-online-learning.vue?vue&type=script&lang=js"
import style0 from "./index-online-learning.vue?vue&type=style&index=0&id=67d6def2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7we4hm3wo3mqgjkrzmyg2igq6e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports